import { motion } from 'framer-motion'
import { type PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export interface StepAnimationProps {
  slideInFromRight?: boolean
}

/**
 * Animate stepping UX.
 */
export const StepAnimation = ({ children, slideInFromRight }: PropsWithChildren<StepAnimationProps>) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        x: slideInFromRight ? '150%' : '-150%',
      }}
      animate={{
        opacity: 1,
        x: '0%',
      }}
      exit={{
        opacity: 0,
        x: '-150%',
      }}
      transition={{
        x: {
          duration: 0.5,
          easings: 'easeOut',
        },
        opacity: {
          duration: 0.25,
          easing: 'easeOut',
        },
      }}
      className={cn('absolute', 'w-fit', 'mx-auto')}
    >
      {children}
    </motion.div>
  )
}
